import GiftCard from '../views/giftcard/Index.vue';
import { checkauth } from '../Helper';
export default [
	{
		path: '/gift-card',
		name: 'giftcard',
		component: GiftCard,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
];
